import { AppThunkAction, AppThunkActionAsync } from "..";
import * as actions from "./actions";
import notificationApi from "../../api/notification";
import { selectNotificationList } from ".";
import { IFilterType } from "../filterType";
import { CancelToken } from "axios";
import {
  listEffectCountFilter,
  listEffectGetFilter,
  listEffectLoad,
  listEffectReload,
  listEffectsCountCheck,
  listEffectsGetCheck,
  listEffectsGetCount,
  listEffectsGetNew,
  listEffectsGetParams,
} from "../listEffect";

export function getNotificationList(
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectNotificationList(getState());
    if (listEffectsGetCheck(state.state)) {
      return;
    }

    let newState = listEffectsGetNew(state);
    dispatch(actions.notificationListFetchRequest(newState.newCountState));
    try {
      const params = listEffectsGetParams(state, newState.take);
      listEffectGetFilter(params, state.filter);

      const notifications = await notificationApi.getList({
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();
      newState = listEffectsGetCount(newState, notifications);

      dispatch(
        actions.notificationListFetchSuccess({
          data: notifications.data,
          newCountState: newState.newCountState,
          newCount: newState.newCount,
        })
      );
    } catch {
      dispatch(
        actions.notificationListFetchError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function getNotificationListCount(
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectNotificationList(getState());
    if (listEffectsCountCheck(state.countState)) {
      return;
    }

    dispatch(actions.notificationListCountRequest());
    try {
      const params = listEffectCountFilter(state.filter);
      const count = await notificationApi.getCount({ params, cancelToken });
      cancelToken.throwIfRequested();

      dispatch(actions.notificationListCountSuccess(count.data));
    } catch {
      dispatch(
        actions.notificationListCountError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function changeNotificationListOrder(
  orderBy: string,
  orderDesc: boolean
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.notificationListChangeOrder({ orderBy, orderDesc }));
  };
}

export function changeNotificationListPage(page: number): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.notificationListChangePage(page));
  };
}

export function changeNotificationListFilter(
  filter: IFilterType
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.notificationListChangeFilter(filter));
  };
}

export function notificationListLoad(reload: boolean): AppThunkAction {
  return async (dispatch, getState) => {
    const state = selectNotificationList(getState());
    reload = listEffectReload(reload, state);
    if (reload) {
      dispatch(actions.notificationListReset());
    } else {
      const newState = listEffectLoad(state);
      dispatch(
        actions.notificationListLoadAction({
          newState: newState.newState,
          newCountState: newState.newCountState,
        })
      );
    }
  };
}
